<li class="nav-item pcoded-menu-caption" *ngIf="item.isPermission"
><label>{{ item.title }}</label></li>
<ng-container *ngIf="item.isPermission">
  @for (item1 of item.children; track item1) {
    @if (item1.type === 'group') {
      <app-nav-group [item]="item1"></app-nav-group>
    }
    @if (item1.type === 'collapse') {
      <app-nav-collapse [item]="item1"></app-nav-collapse>
    }
    @if (item1.type === 'item') {
      <app-nav-item [item]="item1"></app-nav-item>
    }
  }
</ng-container>